import { Mic, Radio, Tv } from 'lucide-react'
import type { SeriesType } from '@/types/series'
import { SERIES_TYPE_LABELS, SERIES_TYPE_DESCRIPTIONS } from '@/types/series'

interface SeriesTypeSelectorProps {
  value: SeriesType
  onChange: (value: SeriesType) => void
  disabled?: boolean
}

const SERIES_TYPE_OPTIONS: {
  value: SeriesType
  icon: React.ElementType
  color: string
}[] = [
  {
    value: 'podcast',
    icon: Mic,
    color: 'border-purple-500 bg-purple-50 dark:bg-purple-900/20',
  },
  {
    value: 'channel',
    icon: Radio,
    color: 'border-blue-500 bg-blue-50 dark:bg-blue-900/20',
  },
  {
    value: 'show',
    icon: Tv,
    color: 'border-rose-500 bg-rose-50 dark:bg-rose-900/20',
  },
]

export function SeriesTypeSelector({
  value,
  onChange,
  disabled,
}: SeriesTypeSelectorProps) {
  return (
    <div className="grid grid-cols-3 gap-3">
      {SERIES_TYPE_OPTIONS.map((option) => {
        const Icon = option.icon
        const isSelected = value === option.value

        return (
          <button
            key={option.value}
            type="button"
            disabled={disabled}
            onClick={() => onChange(option.value)}
            className={`
              flex flex-col items-center gap-2 p-4 rounded-lg border-2 transition-all
              ${
                isSelected
                  ? option.color + ' border-current'
                  : 'border-zinc-200 dark:border-zinc-700 hover:border-zinc-300 dark:hover:border-zinc-600'
              }
              ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
            `}
          >
            <Icon
              className={`w-6 h-6 ${
                isSelected
                  ? 'text-current'
                  : 'text-zinc-400 dark:text-zinc-500'
              }`}
            />
            <span
              className={`text-sm font-medium ${
                isSelected
                  ? 'text-zinc-900 dark:text-zinc-100'
                  : 'text-zinc-600 dark:text-zinc-400'
              }`}
            >
              {SERIES_TYPE_LABELS[option.value]}
            </span>
            <span className="text-xs text-zinc-500 dark:text-zinc-400 text-center">
              {SERIES_TYPE_DESCRIPTIONS[option.value]}
            </span>
          </button>
        )
      })}
    </div>
  )
}
